<template>
    <div style="padding-top: 70px;" class="parent">
        <div class="page-header md-2018121001-xxw">
            <div class="clearfix container">
                <div class="logo-box pull-left">
                    <a class="logo examlogo" href="javascript:;" style="left: 0;top:16px;
                                  font-weight: bold;font-size: 16px;color: #ffffff">职业技能等级认定考试系统</a>
                </div>
                <ul class="nav-xxw pull-left">
                    <li class=""><a class="shouye" href="/">首页</a></li>
                    <li class="active"><a class="examZxks">在线考试</a></li>
                </ul>
                <div class="pull-right">
                    <button @click="exit" class="form-btn form-btn-blue from-save" id="out_login"
                        style="background-color: #4fc7ff;border-color: #4fc7ff;color: #ffffff;">退出</button>
                </div>
            </div>
        </div>

        <div class="page-body ">
            <div class="ka numberCardModal">
                <div class="modal-header">
                </div>
                <div class="modal-body" id="modal-body">
                    <div class="title">
                        <div class="title_border"></div>
                        <div class="title_content">答题卡</div>
                    </div>

                    <div v-for="(item,index) in examSubjectlist" :key="index" class="card-content-list">
                        <div class="card-content">
                            <div v-if="item.queType == '01'" class="card-content-title">单选题(共{{item.SubjectCount}}
                                题，合计{{item.queScoreSum}}分)</div>
                            <div v-if="item.queType == '03'" class="card-content-title">判断题(共{{item.SubjectCount}}
                                题，合计{{item.queScoreSum}}分)</div>

                            <div v-if="item.queType == '02'" class="card-content-title">多选题(共{{item.SubjectCount}}
                                题，合计{{item.queScoreSum}}分)</div>

                            <div v-if="item.queType == '04'" class="card-content-title">填空题(共{{item.SubjectCount}}
                                题，合计{{item.queScoreSum}}分)</div>

                            <div v-if="item.queType == '05'" class="card-content-title">证明题(共{{item.SubjectCount}}
                                题，合计{{item.queScoreSum}}分)</div>

                            <div v-if="item.queType == '06'" class="card-content-title">分析题(共{{item.SubjectCount}}
                                题，合计{{item.queScoreSum}}分)</div>

                            <div v-if="item.queType == '07'" class="card-content-title">解答题(共{{item.SubjectCount}}
                                题，合计{{item.queScoreSum}}分)</div>

                            <div v-if="item.queType == '08'" class="card-content-title">实操题(共{{item.SubjectCount}}
                                题，合计{{item.queScoreSum}}分)</div>
                            <div class="box-list">
                                <div v-if="!handInAnExaminationPaperSwitch"
                                    v-for="(item1,index1) in item.examSubjectSonlist" :key="index1"
                                    class="box normal-box"
                                    :style="item1.userAnswer == null || item1.userAnswer == ''? '':'background: #CCCCCC;'">
                                    <a class="iconBox que-btn"
                                        :style="item1.userAnswer == null || item1.userAnswer == ''? 'color: #616a89;':'color: white;'">{{index1+1}}<input
                                            class="queka" type="hidden" value="que1386"></a>
                                </div>


                                <div v-if="handInAnExaminationPaperSwitch"
                                    v-for="(item1,index1) in item.examSubjectSonlist" :key="index1"
                                    class="box normal-box"
                                    :style="item1.userAnswer == null || item1.userAnswer == ''? 'background: #F1F3F8;':item1.userAnswer == item1.queAnswer? 'background: #1A8CFE;':'background: #FF4B50;'">
                                    <a class="iconBox que-btn"
                                    :style="item1.userAnswer == null || item1.userAnswer == ''? 'background: #F1F3F8;':'color: white;'">{{index1+1}}<input
                                            class="queka" type="hidden"></a>
                                </div>

                            </div>
                            <div class="split"></div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <span class="box icon-box s1"></span>
                    <span class="icon-label">未答</span>
                    <span class="box icon-box s2" style="background-color: #CCCCCC;"></span>
                    <span class="icon-label">已答</span>

                    <span class="box icon-box s2" style="background-color: #1A8CFE;"></span>
                    <span class="icon-label">正确</span>

                    <span class="box icon-box s2" style="background-color: #FF4B50;"></span>
                    <span class="icon-label">错误</span>
                </div>
            </div>
            <div class="container paper-body-xxw"
                style="margin-left: 19%;margin-top: 23px;width: 70%;box-shadow: 0 1px 4px 0 rgba(58, 62, 81, 0.10);">
                <div class="md-2018121002-xxw js-parent-box">

                    <div v-for="(item,index) in examSubjectlist" :key="index" class="other-1221box js-single-box">

                        <div v-if="item.queType == '01'" class="other-1221-hd">单选题<span class="s1">（合计
                                {{item.SubjectCount}} 题，合计 {{item.queScoreSum}}分）</span></div>
                        <div v-if="item.queType == '03'" class="other-1221-hd">判断题<span class="s1">（合计
                                {{item.SubjectCount}} 题，合计 {{item.queScoreSum}}分）</span></div>

                        <div v-if="item.queType == '02'" class="other-1221-hd">多选题<span class="s1">（合计
                                {{item.SubjectCount}} 题，合计 {{item.queScoreSum}}分）</span></div>

                        <div v-if="item.queType == '04'" class="other-1221-hd">填空题<span class="s1">（合计
                                {{item.SubjectCount}} 题，合计 {{item.queScoreSum}}分）</span></div>

                        <div v-if="item.queType == '05'" class="other-1221-hd">证明题<span class="s1">（合计
                                {{item.SubjectCount}} 题，合计 {{item.queScoreSum}}分）</span></div>

                        <div v-if="item.queType == '06'" class="other-1221-hd">分析题<span class="s1">（合计
                                {{item.SubjectCount}} 题，合计 {{item.queScoreSum}}分）</span></div>

                        <div v-if="item.queType == '07'" class="other-1221-hd">解答题<span class="s1">（合计
                                {{item.SubjectCount}} 题，合计 {{item.queScoreSum}}分）</span></div>

                        <div v-if="item.queType == '08'" class="other-1221-hd">实操题<span class="s1">（合计
                                {{item.SubjectCount}} 题，合计 {{item.queScoreSum}}分）</span></div>

                        <div class="other-1221-bd">
                            <div v-for="(item1,index1) in item.examSubjectSonlist" :key="index1"
                                class=" padding-100 js-single-select test-paper-list">
                                <div class="hd">
                                    <div class="tit">

                                        <div style="width: 35px;float:left;">{{index1+1}}.</div>
                                        <i v-if="handInAnExaminationPaperSwitch && item1.userAnswer != item1.queAnswer"
                                            class="xxw107-icon"></i>
                                        <i v-if="handInAnExaminationPaperSwitch && item1.userAnswer == item1.queAnswer"
                                            class="xxw107-icon1"></i>
                                        <div v-html="item1.queQuestion" style="width: 90%;display: inline-block">
                                            <!-- <p>穿管敷设的铝芯绝缘导线的线芯最小截面应为（&nbsp; ）m㎡。</p> -->
                                        </div>

                                        <div v-if="item.queType != '01' && item.queType != '02' && item.queType != '03'&& item.queType != '04' &&  item1.isAtt ==1"
                                            data-queid="6758" class="layui-btn layui-btn-xs queAtt"
                                            style="margin-left: 35px;margin-top: 0px"
                                            @click="DownloadTheAttachment(item1)">附件下载</div>
                                    </div>
                                </div>
                                <!-- 单选题 -->
                                <el-radio-group v-if="item.queType == '01'" class="bd" v-model="item1.userAnswer"
                                    @change="multipleChoice(item1,index,index1)">
                                    <div v-for="(item2,index2) in item1.queOptions" :key="index2"
                                        class="form-checkbox form-checkbox-info item-listx">
                                        <label>
                                            <el-radio :label="item2.serialNum">
                                                <div style="display: flex;">{{item2.serialNum}}. <div
                                                        v-html="item2.optionContent"></div>
                                                </div>
                                            </el-radio>
                                        </label>
                                    </div>
                                </el-radio-group>
                                <!-- 判断题 -->
                                <el-radio-group @change="judgeChoiceChange(item1,index,index1)"
                                    v-if="item.queType == '03'" class="bd" v-model="item1.userAnswer">
                                    <div class="form-checkbox form-checkbox-info item-listx">
                                        <label>
                                            <el-radio label="对">
                                                <div style="display: flex;">对</div>
                                            </el-radio>
                                        </label>
                                    </div>
                                    <div class="form-checkbox form-checkbox-info item-listx">
                                        <label>
                                            <el-radio label="错">
                                                <div style="display: flex;">错</div>
                                            </el-radio>
                                        </label>
                                    </div>
                                </el-radio-group>
                                <!-- 多选题 -->
                                <el-checkbox-group @change="(val)=> multipleChoiceChange(item1,index,index1,val)"
                                    v-if="item.queType == '02'" class="bd" v-model="item1.userAnswerList">
                                    <div v-for="(item2,index2) in item1.queOptions" :key="index2"
                                        class="form-checkbox form-checkbox-info item-listx">
                                        <label>
                                            <el-checkbox :label="item2.serialNum">
                                                <div style="display: flex;">{{item2.serialNum}}. <div
                                                        v-html="item2.optionContent"></div>
                                                </div>
                                            </el-checkbox>
                                        </label>
                                    </div>
                                </el-checkbox-group>


                                <div v-if="handInAnExaminationPaperSwitch" class="md-footer">
                                    <div class="d1 color-28b2f7">【正确答案】{{item1.queAnswer}}</div>
                                    <div class="d1 color-28b2f7">【答案解析】暂无解析 </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div class="nav-wrapper">
                <div class="nav250 nav-status nav-operation">
                    <ul class="menu-items">
                        <li class="menu-item menu-item-time" style="border-bottom: 1px solid #eee;">
                            <div class="item-label">剩余时间</div>
                            <div class="item-data" id="timeDown">{{currentTime}}</div>
                        </li>
                        <li class="menu-item menu-item-process" style="border-bottom: 1px solid #eee;">
                            <div class="item-label">当前进度</div>
                            <div class="item-data" id="jindu"><span id="commitCount">{{currentProgress}}</span>/<span
                                    id="totalCount">{{subjectSumCount}}</span></div>
                            <div class="item-process">
                                <div class="item-process-bar" id="commitProcess"></div>
                            </div>
                        </li>
                        <li class="menu-item menu-item-process" style="border-bottom: 1px solid #eee;">
                            <div class="item-label">得分</div>
                            <div class="item-data" id="userName">{{score}}</div>
                        </li>
                    </ul>
                </div>
                <button href="###" @click="handInAnExaminationPaper" class="form-btn1 form-btn-blue from-save"
                    style="width: 100%;">交卷</button>
            </div>
        </div>
        <el-dialog title="附件下载" :visible.sync="dialogTableVisible" width="30%">
            <el-table :data="thatMaterialList">
                <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
                <el-table-column label="附件名称" width="250" prop="attName" show-overflow-tooltip align="center">
                </el-table-column>

                <el-table-column label="操作" width="120" align="center">
                    <template slot-scope="scope">
                        <el-button type="danger" size="mini" class="layui-btn layui-btn-xs"
                            @click="download(scope.row)">下载</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: 'app',
        compoents: {

        },
        data() {
            return {
                score: 0,
                handInAnExaminationPaperSwitch: false,
                subjectSumCount: 0,
                longTime: 0,
                action: '',
                thatMaterialList: [],
                dialogTableVisible: false,
                radio: '',
                currentTime: '',
                examId: 0,
                examSubjectlist: [],
                endTime: '',
                beginTime: '',
                timer: '',
                mapList: new Map(),
                currentProgress: 0,
                flag: true,
                testId: 0,

            }
        },
        created() {


            this.$watermark({watermark_txt:"职业技能等级认定"})

            document.querySelector('body').setAttribute('style', 'background-color:#eff3f7;')
            if (this.timer) {
                clearInterval(this.timer);
            }

            if (this.$route.params.testId != undefined) {
                console.log('this.$route.params.testId 不为null=====' + this.$route.params.testId);
                this.getTestQuestions(this.$route.params.testId);
            } else {
                console.log('this.$route.params.testId 为null=====');
                this.laodExamSubject(this.$route.params.courseId, this.$route.params.testQueNum);
            }


        },
        mounted() {
            let a = 7200000;
            //定时保存考试内容
            let _this = this;
            this.timer = setInterval(() => {
                a -= 1000;
                _this.currentTime = _this.showtime(a, 0)

            }, 1000)
        },
        beforeDestroy() {
            if (this.timer) {
                clearInterval(this.timer); // 在Vue实例销毁前，清除我们的定时器
            }
        },
        methods: {
            //单体修改
            updateSubject(item, userAnswer) {
                let parames = new URLSearchParams();

                if (this.$route.params.testId != undefined) {
                    parames.append('testId', this.$route.params.testId);
                } else {
                    parames.append('testId', this.testId);
                }

                parames.append('queId', item.queId);//试题id
                parames.append('userAnswer', userAnswer);//用户答案
                parames.append('queAnswer', item.queAnswer);//试题答案
                parames.append('queType', item.queType);//试题类型
                parames.append('queScore', item.queScore); //试题分数

                this.$axios.post(this.serverUrl + '/ex/updateExercisesQuestionOne', parames).then(resp => {

                }).catch(err => {

                })


            },
            //退出
            exit() {
                this.$router.push({ path: '/exercisePreposition/1' });
            },
            dateFormat(fmt, date) {
                let ret;
                const opt = {
                    "Y+": date.getFullYear().toString(),        // 年
                    "m+": (date.getMonth() + 1).toString(),     // 月
                    "d+": date.getDate().toString(),            // 日
                    "H+": date.getHours().toString(),           // 时
                    "M+": date.getMinutes().toString(),         // 分
                    "S+": date.getSeconds().toString()          // 秒
                    // 有其他格式化字符需求可以继续添加，必须转化成字符串
                };
                for (let k in opt) {
                    ret = new RegExp("(" + k + ")").exec(fmt);
                    if (ret) {
                        fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
                    };
                };
                return fmt;
            },
            //加载题信息
            laodExamSubject(courseId, testQueNum) {
                let parames = new URLSearchParams();
                parames.append('userId', this.$storage.get('declareUser').id);
                parames.append('courseId', courseId); //课程id
                parames.append('testQueNum', testQueNum);//试题数量
                parames.append('testType', 1);//测试类型  1模拟测试  2顺序练习
                parames.append('testTypeName', '模拟测试' + this.dateFormat("YYYY-mm-dd HH:MM", new Date()));//模拟考试为：模拟考试+当前时间  顺序练习为：顺序练习+当前时间
                if (this.$route.params.queType != undefined) {
                    parames.append('queType', this.$route.params.queType);//测试类型  1客观题  2实操题
                }
                this.$axios.post(this.serverUrl + '/ex/creatExercises', parames).then(resp => {
                    this.testId = resp.data.data;
                    this.getTestQuestions(resp.data.data);
                }).catch(err => {

                })


            },
            //根据试题id 获取试题
            getTestQuestions(testId) {
                let subjectSumCount = 0;
                let parames1 = new URLSearchParams();
                parames1.append('id', testId); //课程id
                parames1.append('userId', this.$storage.get('declareUser').id); //课程id
                let ArrayList = [];
                let _this = this;
                this.$axios.post(this.serverUrl + '/ex/selectOneUserExercises', parames1).then(resp1 => {
                    resp1.data.data.exercisesAndQueTypes.forEach(function (element, index) {
                        //试题                  
                        let exam = {
                            queType: '', //试题类型
                            typeName: '', //试题类型名称
                            queScoreSum: 0, //试题类型分数总数
                            SubjectCount: 0, //该类型试题数量
                            examSubjectSonlist: []
                        }
                        let questionTypeList = element;
                        exam.queType = questionTypeList.queType;
                        exam.typeName = questionTypeList.typeName;
                        exam.examSubjectSonlist = questionTypeList.exercisesUserQuestionVos;
                        let queScore = 0;
                        let count = 0;
                        questionTypeList.exercisesUserQuestionVos.forEach(function (element1, index1) {
                            count += 1;
                            let enterParameterMultipleChoiceQuestion = element1;
                            queScore += element1.queScore
                            subjectSumCount += 1;
                            let userAnswerList = [];
                            //如果是多选题  则创建数组 用户页面回显用
                            if (element.queType == '02') {
                                if (element1.userAnswer != null && element1.userAnswer != '') {
                                    userAnswerList = element1.userAnswer.split(",");
                                }
                            }
                            element1.userAnswerList = userAnswerList;

                            if (element1.userAnswer != null && element1.userAnswer != '') {
                                _this.currentProgress += 1;

                                element1.flag = false;
                            } else {
                                element1.flag = true;
                            }
                        })
                        exam.queScoreSum = queScore.toFixed(1);
                        exam.SubjectCount = count;
                        ArrayList.push(exam);
                    });
                    this.examSubjectlist = ArrayList;
                    this.subjectSumCount = subjectSumCount;
                }).catch(err => {
                })
            },
            //交卷
            handInAnExaminationPaper() {

                let _this=this;
                this.$confirm('提交后将不能再修改, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    //交卷 算出得分
                    _this.examSubjectlist.forEach(function (element, index) {


                        element.examSubjectSonlist.forEach(function (element1, index1) {

                            if (element.queType == '01' || element.queType == '02' || element.queType == '03') {

                                let isCorrect = false;
                                if (element.queType == '02') {
                                    if (element1.userAnswer != null && element1.queAnswer != null) {
                                        let userAnswerArray = element1.userAnswer.split(",").map(function (ans) { return ans.trim(); }).filter(function (ans) { return ans != ''; }).sort();
                                        let queAnswerArray = element1.queAnswer.split(",").map(function (ans) { return ans.trim(); }).filter(function (ans) { return ans != ''; }).sort();
                                        isCorrect = userAnswerArray.length === queAnswerArray.length && userAnswerArray.join(",") === queAnswerArray.join(",");
                                    }
                                } else {
                                    isCorrect = element1.userAnswer == element1.queAnswer;
                                }

                                if (isCorrect) {

                                    _this.score += element1.queScore;

                                }

                            }

                        })

                    })
                    this.handInAnExaminationPaperSwitch = true;
                }).catch(() => {

                });


            },
            //判断选中
            judgeChoiceChange(item, index, index1) {
                let userAnswer = this.examSubjectlist[index].examSubjectSonlist[index1].userAnswer;
                this.updateSubject(item, userAnswer);

                let flag = this.examSubjectlist[index].examSubjectSonlist[index1].flag
                if (userAnswer != null && userAnswer != '' && flag) {

                    this.currentProgress += 1;
                    this.examSubjectlist[index].examSubjectSonlist[index1].flag = false;
                }
            },
            //多选选中
            multipleChoiceChange(item, index, index1, val) {
                let userAnswer1 = this.examSubjectlist[index].examSubjectSonlist[index1].userAnswer;
                let userAnswer = val.slice().sort().join(",");
                this.examSubjectlist[index].examSubjectSonlist[index1].userAnswer = userAnswer;

                this.updateSubject(item, userAnswer);


                let flag = this.examSubjectlist[index].examSubjectSonlist[index1].flag
                if (userAnswer1 != null && userAnswer1 != '' && flag) {

                    this.currentProgress += 1;
                    this.examSubjectlist[index].examSubjectSonlist[index1].flag = false;
                }

            },
            // 单选选中
            multipleChoice(item, index, index1) {
                let userAnswer = this.examSubjectlist[index].examSubjectSonlist[index1].userAnswer;
                this.updateSubject(item, userAnswer);
                let flag = this.examSubjectlist[index].examSubjectSonlist[index1].flag
                if (userAnswer != null && userAnswer != '' && flag) {
                    this.currentProgress += 1;
                    this.examSubjectlist[index].examSubjectSonlist[index1].flag = false;
                }
            },
            //距离考试结束
            showtime(beginTime, serverTime) {
                var lefttime = beginTime - serverTime;  //距离结束时间的毫秒数
                var leftd = Math.floor(lefttime / (1000 * 60 * 60 * 24));  //计算天数
                var lefth = Math.floor(lefttime / (1000 * 60 * 60) % 24);  //计算小时数
                var leftm = Math.floor(lefttime / (1000 * 60) % 60);  //计算分钟数
                var lefts = Math.floor(lefttime / 1000 % 60);  //计算秒数

                if (lefttime <= 1000) {
                    return "0:0:0"  //返回倒计时的字符串
                } else {
                    return lefth + ":" + leftm + ":" + lefts;  //返回倒计时的字符串
                }
            },
            //附件下载
            download(row) {
                window.open(this.serverUrl + this.prefiexUrl + row.attSrc);
            },
            //附件下载 弹出框
            DownloadTheAttachment(item) {

                let parames = new URLSearchParams();
                parames.append('queId', item.queId);


                let ArrayList = [];
                this.$axios.post(this.serverUrl + '/ex/selectQueAttachment', parames).then(resp => {
                    //能进来此接口就一定有考试信息 直接循环获取

                    resp.data.data.forEach(function (element, index) {

                        ArrayList.push(element);
                    });
                    this.thatMaterialList = ArrayList;

                    this.dialogTableVisible = true;

                }).catch(err => {

                })


            },

        }

    }
</script>

<style scoped>
   body{
            background: #eff3f7;
     }
    .color-28b2f7 {
        color: #28b2f7;
    }

    .md-2018121002-xxw .md-footer {
        background: #f8f8f8;
        padding: 10px 15px;
        margin-top: 20px;
        line-height: 18px;
    }

    .md-2018121002-xxw .md-footer .d1 {
        margin-bottom: 3px;
    }

    .xxw107-icon {
        background: url(../../../static/img/iconxx0107_03.png) no-repeat;
        display: inline-block;
        padding: 8px;
        position: relative;
        top: 2px;
        left: -10px;
    }

    .xxw107-icon1 {
        background: url(../../../static/img/iconxx0107_06.png) no-repeat;
        display: inline-block;
        padding: 8px;
        position: relative;
        top: 2px;
        left: -10px;
    }

    template {
    font-family: '微软雅黑';
    background: #eff3f7;
}

    .el-checkbox__inner {
        display: inline-block;
        position: relative;
        border: 1px solid #DCDFE6;
        border-radius: 2px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        width: 14px;
        height: 14px;
        background-color: #FFF;
        /* z-index: 1; */
        -webkit-transition: border-color .25s cubic-bezier(.71, -.46, .29, 1.46), background-color .25s cubic-bezier(.71, -.46, .29, 1.46);
        transition: border-color .25s cubic-bezier(.71, -.46, .29, 1.46), background-color .25s cubic-bezier(.71, -.46, .29, 1.46);
    }

    .nav-status .menu-item-process .item-data {
        line-height: 17px;
        margin-bottom: 7px;
    }

    .nav-status .menu-item-process .item-label {
        margin-bottom: 11px;
    }

    .nav-status .menu-item-time .item-data,
    .nav-status .menu-item-exam .item-data {
        font-size: 18px;
        line-height: 22px;
        color: #FF0000;
        font-weight: 400;
    }

    .nav-status .menu-item-time .item-label,
    .nav-status .menu-item-exam .item-label {
        margin-bottom: 3px;
    }

    .nav-wrapper .nav250.nav-operation .menu-item {
        padding: 14px 0;
    }

    .form-btn-blue {
        color: #fff;
        background-color: #4b95ff;
        border-color: #4b95ff;
    }

    .nav-wrapper .nav250 {
        color: #27274A;
        line-height: 20px;
        padding: 0 10px;
        background: #FFFFFF;
        box-shadow: 0 1px 4px 0 rgb(0 0 0 / 10%);
        border-radius: 4px;
        margin-bottom: 10px;
        text-align: center;
        list-style: none;
    }


    .nav-wrapper {
        right: 23px;
        bottom: 20px;
        position: fixed;
        top: 90px;
        width: 7%;
    }

    .el-collapse {
        border: 1px solid #EBEEF5;

        padding: 10px;
    }

    .ql-toolbar.ql-snow+.ql-container.ql-snow {
        border-top: 0px;
        height: 150px;
    }

    .layui-btn {
        display: inline-block;
        height: 38px;
        line-height: 38px;
        padding: 0 18px;
        background-color: #009688;
        color: #fff;
        white-space: nowrap;
        text-align: center;
        font-size: 14px;
        border: none;
        border-radius: 2px;
        cursor: pointer;
    }

    .layui-btn-xs {
        height: 22px;
        line-height: 22px;
        padding: 0 5px;
        font-size: 12px;
    }

    .form-checkbox label>input[type="radio"]+p::after {
        display: inline-block;
        position: absolute;
        content: " ";
        width: 8px;
        height: 8px;
        left: 4px;
        top: 7px;
        margin-left: -20px;
        border-radius: 50%;
        background-color: #555555;
        -webkit-transform: scale(0, 0);
        -ms-transform: scale(0, 0);
        -o-transform: scale(0, 0);
        transform: scale(0, 0);
    }

    .form-checkbox label>input[type="radio"]+p::before {
        content: "";
        display: inline-block;
        position: absolute;
        width: 14px;
        height: 14px;
        left: 0;
        top: 3px;
        margin-left: -20px;
        border: 1px solid #cccccc;
        border-radius: 50%;
        background-color: #fff;
    }

    .form-checkbox>label {
        padding-left: 20px;
        position: relative;
    }

    .md-2018121002-xxw .item-listx label {
        display: flex;
        padding: 10px 15px;
        border: 1px solid transparent;
    }

    .md-2018121001-xxw {
        background: #049be2;
        height: 70px;
        line-height: 68px;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        z-index: 1;
    }

    .md-2018121002-xxw .hd>.tit {
        display: flex;
        align-items: baseline;
    }

    .md-2018121002-xxw .hd {
        margin-bottom: 20px;
        color: #333;
        font-weight: bold;
    }

    .padding-100 {
        padding: 70px 100px 20px;
    }

    .md-2018121002-xxw .padding-100 {
        padding-bottom: 0;
        padding-top: 0;
    }

    .md-2018121002-xxw .test-paper-list {
        margin-bottom: 24px;
    }

    .other-1221-hd .s1 {
        font-size: 16px;
    }

    .other-1221-hd {
        padding: 0 22px;
        line-height: 42px;
        background: #d4f0fd;
        color: #014c85;
        font-size: 22px;
        width: 95%;
        margin: 0 auto;
        margin-bottom: 36px;
    }

    .paper-body-xxw {
        background: #fff;
        margin-bottom: 60px;
        padding-bottom: 40px;
        position: relative;
        padding-top: 50px;
        margin-left: 265px;
    }

    .s2 {
        background: #1A8CFE;
    }

    .icon-label {
        font-family: PingFangSC-Regular;
        font-size: 12px;
        color: #656577;
    }

    .icon-box.s1 {
        background: #F1F3F8;
    }

    .modal-footer {
        padding: 10px 20px 10px 0px;
        background-color: #fff;
        border: unset;
        box-shadow: 0 -2px 10px 0 rgb(58 62 81 / 10%);
        text-align: right;
    }

    .iconBox {
        line-height: 32px;
        font-size: 14px;
        display: inline-block;
        width: 100%;
        height: 0%;
        color: #616a89;
        border-radius: 2px 2px 0 0;
    }

    .box {
        height: 32px;
        width: 32px;
        line-height: 18px;
        padding-bottom: 0;
        font-size: 0;
        display: inline-block;
        text-align: center;
        background: #F1F3F8;
        line-height: 12px;
        position: relative;
        margin: 0 3px 6px;
        border-radius: 2px 2px 0 0;
        overflow: hidden;
    }

    .s2 {
        background: #1A8CFE;
    }

    .icon-box {
        width: 10px;
        height: 10px;
        display: inline-block;
        margin: 0 3px 0px;
        padding-bottom: 0px;
    }

    .box-list .s1 {
        background: #F1F3F8;
    }

    .box-list {
        position: relative;
        left: -5px;
        font-size: 0;
        margin-right: -15px;
    }

    .card-content-title {
        font-size: 14px;
        color: #27274A;
        font-weight: 600;
        padding-bottom: 12px;
        padding-top: 20px;
    }

    .card-content {
        padding: 0 20px 0 20px;
        position: relative;
    }

    .card-content-list {
        font-size: 12px;
        color: #27274A;
        font-weight: 600;
    }

    .title_content {
        margin-left: 14px;
        font-weight: 600;
        color: #27274A;
    }

    .title_border {
        display: inline-block;
        width: 4px;
        height: 18px;
        background: #1A8CFE;
        position: absolute;
        top: 0;
        bottom: 0;
        margin: auto;
    }

    .title {
        position: relative;
        text-align: left;
        margin-left: 20px;
        margin-bottom: 0;
        font-size: 18px;
        padding-bottom: 0px;
        color: #666666;
        letter-spacing: 0;
    }

    .modal-body {
        overflow-y: auto;
        height: 494px;
        padding-bottom: 36px;
    }

    .modal-header {
        padding: 10px;
        /* height: 20px; */
        border: none;
    }

    .ka {
        width: 15%;
        height: 550px;
        left: 37px;
        float: left;
        position: fixed;
        top: 93px;
        background-color: white;
        z-index: 999;
        box-shadow: 0 1px 4px 0 rgb(58 62 81 / 10%);
    }

    .parent {
        font-family: Microsoft YaHei, Helvetica Neue, Helvetica, STHeiTi, Arial, sans-serif;
        font-size: 16px;
        line-height: 1.4;
    }

    .md-2018121001-xxw .nav-xxw li a {
        display: block;
        color: inherit;
    }

    .md-2018121001-xxw .nav-xxw .active {
        color: #ffcc33;
        font-weight: bold;
    }

    .form-btn1 {
        display: inline-block;
        padding: 5px 0px 6px;
        margin-bottom: 0;
        font-size: 14px;
        font-weight: normal;
        line-height: 1.42857143;
        text-align: center;
        white-space: nowrap;
        vertical-align: middle;
        -ms-touch-action: manipulation;
        touch-action: manipulation;
        cursor: pointer;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        background-image: none;
        border: 1px solid transparent;
        border-radius: 4px;
        /* height: 32px; */
    }

    .form-btn {
        display: inline-block;
        padding: 5px 20px 6px;
        margin-bottom: 0;
        font-size: 14px;
        font-weight: normal;
        line-height: 1.42857143;
        text-align: center;
        white-space: nowrap;
        vertical-align: middle;
        -ms-touch-action: manipulation;
        touch-action: manipulation;
        cursor: pointer;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        background-image: none;
        border: 1px solid transparent;
        border-radius: 4px;
        /* height: 32px; */
    }

    .ks-btn {
        display: inline-block;
        line-height: 26px;
        background: #29b2f7;
        color: #fff;
        padding: 2px 8px;
        border-radius: 4px;
        cursor: pointer;
    }

    .layui-bg-gray {
        background-color: #eee !important;
        color: #666 !important;
    }

    .layui-badge {
        height: 18px;
        line-height: 18px;
        position: relative;
        display: inline-block;
        padding: 0 6px;
        font-size: 12px;
        text-align: center;
        color: #fff;
        border-radius: 2px;
    }

    .ks-typex {
        display: inline-block;
        line-height: 26px;
        background: #ec7064;
        color: #fff;
        padding: 0 16px;
        border-radius: 15px;
    }

    .layui-icon-search:before {
        content: "\e615";
    }

    .layui-icon {
        font-family: layui-icon !important;
        font-size: 16px;
        font-style: normal;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }

    .md-2018121102-xxw .form-group span {
        width: 48px;
        height: 50px;
        font-size: 24px;
        background: #bdc3c7;
        text-align: center;
        line-height: 46px;
        color: #fff;
        cursor: pointer;
    }

    .md-2018121102-xxw .form-group input {
        width: 750px;
        height: 100%;
        padding-left: 10px;
        background: #fdfdfd;
        border: none;
    }

    .md-2018121102-xxw .form-group {
        width: 800px;
        height: 48px;
        border-radius: 4px;
        border: 1px solid #bdc3c7;
        overflow: hidden;
    }

    .md-2018121102-xxw>.md-bd {
        padding: 30px 40px;
    }

    .color-28b2f7 {
        color: #28b2f7;
    }

    .bg-fff {
        background: #fff;
    }

    .padding-40px {
        padding: 0 40px;
    }

    .md-2018121102-xxw .md-hd {
        line-height: 50px;
        margin: 28px 0;
        border-radius: 8px;
        font-size: 16px;
        font-weight: bold;
    }

    .aaaaa {
        background: #f3f2f2;
        line-height: 24px;
        font: 14px Helvetica Neue, Helvetica, PingFang SC, Tahoma, Arial, sans-serif;
    }

    .md-2018121001-xxw .nav-xxw li {
        float: left;
        margin-right: 35px;
    }

    .md-2018121001-xxw .nav-xxw .active {
        color: #ffcc33;
        font-weight: bold;
    }

    .md-2018121001-xxw .nav-xxw {
        color: #ffffff;
        margin-left: 68px;
        font-size: 16px;
    }

    a {
        color: #333;
        text-decoration: none;
    }

    .container {
        clear: both;
        margin: 0 auto;
        text-align: left;
        width: 1200px;
    }

    .pull-left {
        float: left;
    }

    .pull-right {
        float: right;
    }
</style>


// WEBPACK FOOTER //
// src/components/exercise/mockTest.vue